import { Payload } from 'Models/UI/Payload';

export class PayloadPayment implements Payload {
    paymentType : string;
    // for sepa direct debit payment
    paymentAccountHolder: string;
    paymentIban: string;
    paymentBic: string;
}